import Vue from 'vue'
import axios from 'axios';
import store from '../store/index'
import router from '../router/index'
import { Dialog, Toast } from 'vant'
import { getToken, setToken, removeToken } from '@/utils/auth'

function navHide(arr, name) {
  return arr.indexOf(name) > -1 ? true : false
}

function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
  if (ua.indexOf('micromessenger') > -1) {
    return true; // 是微信端
  } else {
    return false;
  }
}

export {
  navHide, isWeiXin
}

// Vue.prototype.goPage = (url) => {
//   if (url && (url.name || url.path)) router.push(url);
// }

Vue.prototype.toCash = (value) => {
  // 返回处理后的值
  if (value == null || value == undefined || value == "") {
    return 0;
  } else if (value == 0) {
    return value;
  } else {
    return value.toFixed(2);
  }
}

Vue.prototype.parseToJson = (url) => {
  if (url != "" && url.indexOf("?") != -1) {
    let url_json = {};
    url = url.replace("#/author", "");
    url = url.split("?");
    url = url[1].split('&');
    for (let i = 0; i < url.length; i++) {
      let str = url[i].split('=');
      url_json[str[0]] = str[1];
    }
    return url_json;
  } else {
    return "";
  }
}

// 是否登录
Vue.prototype.MakeCall = () => {
  Vue.prototype.$post('/api/sys_config', { group: 'basic' }, { group: 'basic' }).then(function (e) {
    // console.log(e.data.data,'d')
    if (e.data.code == 0) {
      Dialog.confirm({
        title: "提示",
        message: `是否拨打客服电话？\n(${e.data.data.companyTel})`,
        theme: "round-button",
        confirmButtonText: "拨打",
        confirmButtonColor: "#ff5000",
        cancelButtonColor: "#CCCCCC",
      })
        .then(() => {
          // on confirm
          window.location.href = `tel:${e.data.data.companyTel}`;
        })
        .catch(() => {
          // on cancel
        });
    } else {
      Toast.fail(e.data.message);
    }
  });
}
// 是否登录
Vue.prototype.isLogin = () => {
  if (!Lockr.get("userId") && !store.getters.userId){
    Dialog.confirm({
      title: '提示',
      message: '该功能需要您登录，是否前往登录？',
      theme: 'round-button',
      confirmButtonText: '去登录',
      confirmButtonColor: '#ff5000',
      cancelButtonColor: '#CCCCCC'
    })
      .then(() => {
        // on confirm
        // Lockr.set("oldUrl", { name: 'index' });
        router.push({ name: 'login' });
      })
      .catch(() => {
        // console.log()
        if (router.currentRoute.name == 'index') return;
        router.replace({ name: 'index' });
        // on cancel 
      });


  } else {
    return true
  }
}

// 获取用户信息
Vue.prototype.getUserInfo = (url) => {
  Vue.prototype.$post('/api/refreshUid',
    { openid: Lockr.get("openId") },
    { openid: Lockr.get("openId") },
  ).then(function (res) {
    // console.log(res.data,'全局获取用户信息')
    if (res.data && res.data.code == 0) {

      Lockr.set("openId", res.data.data.open_id);
      store.commit("setOpenId", res.data.data.open_id);

      Lockr.set("userId", res.data.data.user_id); // uid
      store.commit("set_user_id", res.data.data.user_id);

      Lockr.set("userInfo", res.data.data); //用户信息
      Lockr.set("user_type", res.data.data.user_type); //用户类型


      Lockr.set("referral_code", res.data.data.invite_code); // 邀请码
      store.commit("set_referral_code", res.data.data.invite_code);


      Lockr.set("mobile", res.data.data.phone_no); // 手机号
      store.commit("set_Mobile", res.data.data.phone_no);

      // refreshUid

      // "user_nickname": "BFBNyJZG",
      // "sex": 1,
      // "head_photo": "http:\/\/weizhui.xzbfb.com\/static\/avatar.jpg",
      // "phone_no": "18839135695",
      // "open_id": "oo05wvzjtnTRFecFjBLPY_ZMI5_M",
      // "invite_code": "XQJD8V",
      // "user_id": "5d022c3ad6fc4c0d6f9183dd7cbb6719",

      // user_info

      // user_nickname": "BFBNyJZG",
      // "phone_no": "18839135695",
      // "sex": 1,
      // "head_photo": "http:\/\/weizhui.xzbfb.com\/static\/avatar.jpg",
      // "open_id": "oo05wvzjtnTRFecFjBLPY_ZMI5_M",
      // "invite_code": "XQJD8V", 

      if (url) {
        if (url == -1) {
          router.go(-1);
        } else {
          router.replace(url);
        }
      }
    } else if (res.data.code == -1) {
      sessionStorage.clear(); //清除数据
      Lockr.rm("userId");
      Lockr.rm("mobile");
      Lockr.rm("headImgUrl");
      Lockr.rm("user_nickname");
      removeToken();
      // Toast.fail('登陆超时~');
      // router.push({ name: 'login' });
    } else {
      Toast.fail(res.data.message);
    }
  });
};



// 获取用户信息
Vue.prototype.getUserInfoData = (url) => {
  Vue.prototype.$post('/api/user_info',).then(function (res) {
    // console.log(res.data,'全局获取用户信息')
    if (res.data && res.data.code == 0) {

      Lockr.set("openId", res.data.data.open_id);
      store.commit("setOpenId", res.data.data.open_id);

      // Lockr.set("userId", res.data.data.user_id); // uid
      // store.commit("set_user_id", res.data.data.user_id);

      Lockr.set("userInfo", res.data.data); //用户信息
      store.commit("saveUser", res.data.data);

      Lockr.set("user_type", res.data.data.user_type); //用户类型


      Lockr.set("referral_code", res.data.data.invite_code); // 邀请码
      store.commit("set_referral_code", res.data.data.invite_code);


      Lockr.set("mobile", res.data.data.phone_no); // 手机号
      store.commit("set_Mobile", res.data.data.phone_no);
    } else {
      Toast.fail(res.data.message);
    }
  });
};


